export type IOrientType = 'left' | 'top' | 'right' | 'bottom' | 'z';
